<template>
  <v-container class="pt-5 pb-7">
    <v-layout wrap>
      <v-flex v-if="!getWorkflowStatus" class="text-xs-center pt-5">
        <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
      </v-flex>

      <v-flex v-if="getWorkflowStatus === 'Under Construction'" md8>
        <h3>Unavailable for review</h3>
        <p>This course is still under construction and is not available to review at this time. You will be notified when the author has submitted their curriculum for review.</p>
      </v-flex>
    </v-layout>

    <review-screen v-if="getWorkflowStatus !== 'Under Construction' && !loadingMetaData" :course-id="courseId" edit-access />

    <template v-if="!loadingMetaData && getWorkflowStatus === 'Ready for Review'">
      <v-divider class="my-5" />
      <div class="text-xs-center">
        <h3>Finished with your peer review?</h3>
        <div class="mt-3">
          <v-btn color="secondary" @click="completeReview('Changes Requested')">
            Request Author Changes
          </v-btn>
          <v-btn color="secondary" @click="completeReview('No Changes Requested')">
            Ready for Publication
          </v-btn>
        </div>
      </div>
    </template>
  </v-container>
</template>
<script>
  import axios from 'axios';
  import { mapActions } from 'vuex';
  import ManageCourseBase from '../ManageCourseBase.vue';
  import ReviewScreen from './ReviewScreen.vue';

  export default {
    components: {
      ReviewScreen,
    },
    extends: ManageCourseBase,

    data: () => ({
      metadata: null,
      loadingMetaData: true,
      workflowStatuses: [],
    }),

    computed: {
      getWorkflowStatus() {
        if (this.metadata) {
          return this.metadata.workflowStatus ? this.metadata.workflowStatus.name : null;
        }

        return null;
      },
    },

    mounted() {
      this.getMetadata().then(() => {
        this.loadingMetaData = false;
      });
    },

    methods: {
      ...mapActions({
        setToast: 'toasts/addToGlobalToastQueue',
      }),

      async getMetadata() {
        const { data } = await axios.get(`/api/courses/${this.courseId}`);
        this.metadata = data;
      },

      async completeReview(reviewType) {
        await axios.post(`/api/courses/${this.courseId}/workflow/complete-review?requestType=${reviewType}`);
        await this.getMetadata();
        this.setToast({
          color: 'success',
          message: 'This course has progressed to the next step',
          multiline: false,
        });
      },
    },
  };
</script>